import { create } from 'zustand'
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from 'zustand/middleware'

export type SignUpHostComplete = {
  surveyAvailable: boolean
  signUpCompleteTime: string
  verificationType: 'phone' | null
}

type SignUpHostCompleteStore = {
  complete: SignUpHostComplete
  isHydrated: boolean
  actions: {
    updateComplete: (data: SignUpHostComplete) => void
    updateIsHydrated: () => void
    reset: () => void
  }
}
const initialState = {
  complete: {
    surveyAvailable: false,
    signUpCompleteTime: '',
    verificationType: null,
  },
  isHydrated: false,
}

export const useSignUpHostCompleteStore = create<SignUpHostCompleteStore>()(
  subscribeWithSelector(
    persist(
      set => ({
        ...initialState,
        actions: {
          updateComplete: data => {
            set(state => ({
              complete: { ...state.complete, ...data },
            }))
          },
          updateIsHydrated: () => {
            set(() => ({
              isHydrated: true,
            }))
          },
          reset: () => {
            set(initialState)
          },
        },
      }),
      {
        name: 'sign-up-host-complete',
        storage: createJSONStorage(() => sessionStorage),
        partialize: state => ({
          complete: state.complete,
        }),
      },
    ),
  ),
)
